import { render } from "./FormFourthStep.vue?vue&type=template&id=d44bcd48&scoped=true"
import script from "./FormFourthStep.vue?vue&type=script&lang=js"
export * from "./FormFourthStep.vue?vue&type=script&lang=js"

import "./FormFourthStep.vue?vue&type=style&index=0&id=d44bcd48&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d44bcd48"]])

export default __exports__